export abstract class CrudAbstractModel {
  protected constructor(public id?: number) {}

  public getId(): number {
    return this.id;
  }

  public abstract getRequestParams(): any;
}
